import { TextField } from "@root/shared/components/TextField";
import { Button } from "@root/shared/components/Button";
import { ErrorInformationText } from "@root/userFrontend/components/ErrorInformationText";
import { useStep1Form } from "@userFrontend/features/registration/hooks/useStep1Form";
import { Step1HiddenForm } from "@userFrontend/features/registration/components/Step1HiddenForm";
import * as styles from "./styles.css";

export type ScoutStep1FormProps = {
  action: string;
  emailDuplicateCheckPath: string;
  privacyPolicyPath: string;
  termsPath: string;
  defaultEmailErrorMessages?: string[];
  defaultPasswordErrorMessages?: string[];
};

export const ScoutStep1Form = (props: ScoutStep1FormProps) => {
  const {
    action,
    emailDuplicateCheckPath,
    defaultEmailErrorMessages,
    defaultPasswordErrorMessages,
    privacyPolicyPath,
    termsPath,
  } = props;

  const { formRef, email, password, handleSubmitButtonClick, isSubmitButtonDisabled } =
    useStep1Form({
      mode: "onChange",
      emailDuplicateCheckPath,
      defaultEmailErrorMessages,
      defaultPasswordErrorMessages,
    });

  return (
    <>
      <Step1HiddenForm
        formRef={formRef}
        action={action}
        emailValue={email.value}
        passwordValue={password.value}
      />
      <div className={styles.container}>
        <div className={styles.fields}>
          <div className={styles.fieldContainer}>
            <label htmlFor="email" className={styles.label}>
              メールアドレス
            </label>
            <TextField
              {...email.register}
              id="email"
              type="email"
              placeholder="入力してください"
              className={styles.textField}
            />
            <div role="region" aria-label="メールアドレスのエラー">
              {email.errorMessages.map((msg) => (
                <ErrorInformationText key={msg} text={msg} />
              ))}
            </div>
          </div>
          <div className={styles.fieldContainer}>
            <label htmlFor="password" className={styles.label}>
              パスワード
              <span className={styles.passwordHint}>（半角英数字、記号2種類以上、8文字以上）</span>
            </label>
            <TextField
              {...password.register}
              id="password"
              type="password"
              placeholder="半角英数字、記号2種類以上、8文字以上"
              className={styles.textField}
            />
            <div role="region" aria-label="パスワードのエラー">
              {password.errorMessages.map((msg) => (
                <ErrorInformationText key={msg} text={msg} />
              ))}
            </div>
          </div>
        </div>
        <p className={styles.termsText}>
          会員登録を行った場合、弊社の
          <a href={privacyPolicyPath} target="_blank" rel="noopener noreferrer">
            個人情報保護方針
          </a>
          と<br />
          <a href={termsPath} target="_blank" rel="noopener noreferrer">
            利用規約
          </a>
          に同意したものとみなされます
        </p>
        <Button
          type="button"
          onClick={handleSubmitButtonClick}
          size="large"
          theme={isSubmitButtonDisabled ? "disabled" : "primary"}
          className={`${styles.submitButton} ${isSubmitButtonDisabled ? styles.submitButtonDisabled : ""}`}
        >
          この情報で登録する
        </Button>
      </div>
    </>
  );
};
